import { LightboxesService } from './../lightboxes.service';
import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-ligthboxes-default',
    templateUrl: './default.component.html',
    styleUrls: ['./default.component.scss'],
    standalone: false
})
export class DefaultLightBoxesComponent implements OnInit {

  constructor(private service: LightboxesService) {}

  ngOnInit() {}
  
  close() {
    this.service.close()
  }

}